import { connect } from 'react-redux'
import { QUESTION_TYPE_MAP } from 'utils/constants'
import LogicPanel from '../components/ItemEditor/LogicPanel'
import { logicActions } from '../modules/Survey'
import { stripHtmlTags } from 'utils/misc'
import { isVersionUatOrLive } from 'utils/studyConfigUtils'

const mapDispatchToProps = logicActions

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const { itemId } = ownProps
  const { questions } = state.surveyEditor.survey
  const order = state.surveyEditor.survey.order[0]
  const currentIndex = order.indexOf(itemId)

  const { studyVersionList } = state?.study

  const hasStudyPromotion = !!state?.study?.currentStudy?.config?.study_promotion
  const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

  const questionOptions = []
  let questionNumber = 0
  const questionTypesWithNestedQuestionsArr = [QUESTION_TYPE_MAP.matrix]
  for (let i = 0; i < currentIndex; i++) {
    const questionType = questions[order[i]].type
    if (questionType.includes(QUESTION_TYPE_MAP.introduction)) continue
    if (questionType.includes(QUESTION_TYPE_MAP.prompt)) continue
    if (questionType.includes(QUESTION_TYPE_MAP.timer)) continue
    if (questionType.includes(QUESTION_TYPE_MAP.imageCapture)) {
      questionNumber++
      continue
    }
    if (questionType.includes(QUESTION_TYPE_MAP.multipleField)) {
      questionNumber++
      continue
    }
    if (questionType.includes(QUESTION_TYPE_MAP.audioRecording)) {
      questionNumber++
      continue
    }
    if (questionType.includes(QUESTION_TYPE_MAP.scribble)) {
      questionNumber++
      continue
    }
    if (questionTypesWithNestedQuestionsArr.includes(questionType)) {
      questionNumber++
      const parentQuestion = questions[order[i]]
      const { questions_order: questionsOrder } = parentQuestion || {}
      const currentQuestionNumber = questionNumber

      ;(questionsOrder || []).forEach((nestedQuestionId, index) => {
        const nestedQuestion = parentQuestion.questions[nestedQuestionId]
        if (!nestedQuestion) return
        const plainQuestionText = nestedQuestion.label
        let text = `Q${currentQuestionNumber}.${index + 1}: ${stripHtmlTags(plainQuestionText)}`
        if (text.length > 40) text = `${text.slice(0, 40)}...`
        questionOptions.push({
          key: nestedQuestionId,
          text,
          value: order[i],
          value2: nestedQuestionId,
        })
      })
      continue
    }
    const plainText = stripHtmlTags(questions[order[i]].label)
    questionNumber++
    let text = `Q${questionNumber}: ${plainText}`
    if (text.length > 40) text = `${text.slice(0, 40)}...`
    questionOptions.push({
      key: order[i],
      text,
      value: order[i],
    })
  }

  return {
    logic: state.surveyEditor.survey.questions[itemId].logic.show_if,
    questionOptions,
    questions,
    logicErr: state.surveyEditor.surveyErrors.questions[itemId],
    isReadOnlyState,
    studyVersionID,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogicPanel)
